import type { BriefResponseDto } from '@inference.engine/workspace-api-client/web';

export interface BriefReviewInput {
  title: string;
  summary: string | null;
  audienceIds: string[];
  sections: { sectionId: string; name: string; contentText: string }[];
}

/** Depth-first concatenation of all `text` nodes in a Tiptap doc, paragraphs separated by newlines. */
export function tiptapToPlainText(doc: Record<string, unknown> | null | undefined): string {
  if (!doc) return '';
  const walk = (node: Record<string, unknown>): string => {
    if (node.type === 'text') return typeof node.text === 'string' ? node.text : '';
    const children = (node.content as Record<string, unknown>[] | undefined) ?? [];
    const inner = children.map(walk).join('');
    return node.type === 'paragraph' ? `${inner}\n` : inner;
  };
  return walk(doc).trim();
}

export function serializeBriefForReview(
  brief: BriefResponseDto,
  projectAudienceIds: readonly string[],
): BriefReviewInput {
  const sections = brief.sections.map((s) => ({
    sectionId: s.id,
    name: s.name,
    contentText: tiptapToPlainText(s.content as Record<string, unknown> | null),
  }));

  // Every audience associated with the project auto-reviews the brief.
  const audienceIds = [...new Set(projectAudienceIds)];

  return { title: brief.title, summary: brief.summary ?? null, audienceIds, sections };
}
